module.exports = __webpack_public_path__ + "static/media/OSTR05.a496ec61.jpg";